import { useCallback } from 'react';
import { Success } from 'shared/components/Success';
import { useAppDispatch } from 'shared/hooks';
import { setModalVisible } from 'shared/slices';

export const SuccessContainer: React.FC = () => {
  const dispatch = useAppDispatch();

  const handleModalClose = useCallback(() => {
    dispatch(setModalVisible(false));
  }, [dispatch]);

  return <Success onCloseModal={handleModalClose} />;
};
